var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.53033 8.96967C7.23744 8.67678 6.76256 8.67678 6.46967 8.96967C6.17678 9.26256 6.17678 9.73744 6.46967 10.0303L11.4697 15.0303C11.7626 15.3232 12.2374 15.3232 12.5303 15.0303L17.5303 10.0303C17.8232 9.73744 17.8232 9.26256 17.5303 8.96967C17.2374 8.67678 16.7626 8.67678 16.4697 8.96967L12 13.4393L7.53033 8.96967Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowClosed);
export default __webpack_public_path__ + "static/media/ArrowClosed.dae3340bd0b292ade9085075dcf1d9e8.svg";
export { ForwardRef as ReactComponent };